import type { CodingScreenState } from '../../project_starburst/interface';
import type { ActionPermissions } from '../../project_starburst/interface/api';

export const injectActionPermissions = (
  state: CodingScreenState,
  permissions: ActionPermissions | undefined
): CodingScreenState => {
  if (!state) return state;
  const transfer = (state.values?.['case.transfer'] ?? {}) as Record<string, unknown>;
  return {
    ...state,
    values: {
      ...state.values,
      'case.excludeContext': { canExclude: permissions?.canExclude === true },
      'case.transfer': { ...transfer, permission: permissions?.transfer ?? 'loading' }
    }
  };
};
